import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import ImageCarousel from 'components/layout/ImageCarousel/ImageCarousel';
import { Constants } from 'utilities/constants';

const UnderwritePictures = ({ containerClass, classes, images, isFetchingImages }) => {
  return (
    <div className={containerClass}>
      <div className={classes.picturesWrapper}>
        {images && <ImageCarousel imageSources={images} isLoading={isFetchingImages}/>}
      </div>
    </div>
  )
}

const styles = theme => ({
  picturesWrapper: {
    width: '100%',
  },
  imageGallery: {
    height: '100%',
    width: '100%'
  }
});

const mapStateToProps = (state, ownProps) => {
  const moduleState = ownProps.module === Constants.Module.POSTACQ ? state.postAcqUWState : state.propertyUWState;
  const isFetchingImages = ownProps.module === Constants.Module.POSTACQ ? moduleState.isFetchingPostAcqUWImages : moduleState.isFetchingPropertyUWImages;
  return {
    images: moduleState.selectedOpportunityImages,
    isFetchingImages
  }
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(UnderwritePictures);
